import Styled from 'styled-components';

// const InfoWraper = Styled.div`
//     display: flex;
//     justify-content:center;
//     align-items: center;
//     padding: 16px 0;   
//     .fullscreen{ 
//         display: flex;
//         span{
//             svg{
//                 display: block;
//                 line-height: normal;
//                 margin: 0 3px;
//             }
//         }
//     }  
         
//     .nav-author{
//         display: flex;
//         span, a{
//             display: block;
//             line-height: normal;
//             margin: 0 3px;
//             span.ant-avatar-image {
//                 background: #efefef;
//                 border-radius: 5px;
//             }

//         }
//         a {
//             display: flex;
//             align-items: center;
//             gap: 8px;
//             text-decoration: none;
//             color:#fff;
//             font-weight:700;
//         }
//     }
//     .nav-author{
//         a.ant-dropdown-trigger{
//             img{
//                 max-width: 20px;
//             }
//         }
//     }
// `;

const InfoWraper = Styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 24px; 
    @media (max-width: 768px) {
        gap: 12px;
    }
    
    .language, .fullscreen, .themestyle, .nav-author {
        display: flex;
        align-items: center;
        gap: 8px;
        span {
            display: flex;
            gap: 8px;
            .lang-selector {
                color: ${({ darkMode, theme }) => (darkMode ? '#1e1616ff' :  '#FFF')};
                font-weight: 600;
                @media (max-width: 768px) {
                    display: none;
                }
            }
        }
    }

    .icon-button {
        font-size: 18px;
        color: ${({ darkMode, theme }) => (darkMode ? '#1e1616ff' :  '#FFF')};
        cursor: pointer;
        display: flex;
        align-items: center;
    }

    

    .nav-author a {
        display: flex;
        align-items: center;
        gap: 8px;
        color: #fff;
        font-weight: 700;
        text-decoration: none;
        .user-first__name {
            @media (max-width: 576px) {
                display: none;
            }
        }
    }

    .notification-bell--active svg {
        transform-origin: 50% 4px;
        animation: notification-bell-ring 1.2s ease-in-out infinite;
    }

    .notification-bell--active:hover svg {
        animation-play-state: paused;
    }

    @keyframes notification-bell-ring {
        0%, 100% {
            transform: rotate(0deg);
        }
        8%, 24%, 40% {
            transform: rotate(14deg);
        }
        16%, 32%, 48% {
            transform: rotate(-14deg);
        }
        56% {
            transform: rotate(8deg);
        }
        64% {
            transform: rotate(-8deg);
        }
        72% {
            transform: rotate(0deg);
        }
    }

    .ant-avatar {
        background: #efefef;
        border-radius: 5px;
    }
`;

const SettingDropdwon = Styled.div`
    .setting-dropdwon{
        max-width: 700px;
        padding: 4px 0;
        .setting-dropdwon__single{
            align-items: flex-start;
            padding: 16px 20px;
            margin-bottom: 0;
            position: relative;
            &:after{
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                box-shadow: 0 5px 20px ${({ theme }) => theme['gray-solid']}15;
                z-index: 1;
                content: '';
                opacity: 0;
                visibility: hidden;
            }
            &:hover{
                &:after{
                    opacity: 1;
                    visibility: visible;
                }
            }
            h1{
                font-size: 15px;
                font-weight: 500;
                margin: -4px 0 2px;
            }
            p{
                margin-bottom: 0;
                color: ${({ theme }) => theme['gray-solid']};
            }
            img{
                ${({ theme }) => (theme.rtl ? 'margin-left' : 'margin-right')}: 16px;
                transform: ${({ theme }) => (theme.rtl ? 'rotatey(180deg)' : 'rotatey(0deg)')};
            }
            figcaption{
                text-align: ${({ theme }) => (!theme.rtl ? 'left' : 'right')}
            }
        }
    }
`;

const NestedDropdwon = Styled.div`
    .support-dropdwon{
        padding: 10px 15px;
        text-align: ${({ theme }) => (!theme.rtl ? 'left' : 'right')};
        ul{
            &:not(:last-child){
                margin-bottom: 16px;
            }
            h1{
                font-size: 14px;
                font-weight: 400;
                color: ${({ theme }) => theme['light-color']};
            }
            li{
                a{
                    font-weight: 500;
                    padding: 4px 16px;
                    color: ${({ theme }) => theme['dark-color']};
                    &:hover{
                        background: #fff;
                        color: ${({ theme }) => theme['primary-color']};
                    }
                }
            }
        }
    }
`;

const UserDropDwon = Styled.div`
    .user-dropdwon{
        width: 280px;
        .user-dropdwon__info{
            display: flex;
            align-items: flex-start;
            padding: 20px 25px;
            border-radius: 8px;
            margin-bottom: 12px;
            background: ${({ theme }) => theme['bg-color-normal']};
            img{
                ${({ theme }) => (theme.rtl ? 'margin-left' : 'margin-right')}: 15px;
            }
            figcaption{
                h1{
                    font-size: 14px;
                    margin-bottom: 2px;
                    color:  ${({ theme }) => theme['dark-color']};
                }
                p{
                    margin-bottom: 0px;
                    font-size: 13px;
                    color: ${({ theme }) => theme['gray-solid']};
                }
            }
        }
        .user-dropdwon__links{
            a{
                // width: calc(100% + 30px);
                left: -15px;
                right: -15px;
                display: inline-flex;
                align-items: center;
                padding: 10px 12px;
                font-size: 14px;
                transition: .3s;
                color: ${({ theme }) => theme['light-color']};
                &:hover{
                    background: ${({ theme }) => theme['primary-color']}05;
                    color: ${({ theme }) => theme['primary-color']};
                    ${({ theme }) => (theme.rtl ? 'padding-right' : 'padding-left')}: 22px;
                }
                svg{
                    width: 16px;
                    transform: ${({ theme }) => (theme.rtl ? 'rotateY(180deg)' : 'rotateY(0deg)')};
                    ${({ theme }) => (theme.rtl ? 'margin-left' : 'margin-right')}: 14px;
                }
            }
        }
        .user-dropdwon__bottomAction{
            display: inline-flex;
            align-items: center;
            justify-content: center;
            font-size: 13px;
            font-weight: 500;
            text-align: center;
            position: relative;
            width: calc(100% + 30px);
            left: -15px;
            right: -15px;
            height: calc(100% + 15px);
            bottom: -15px;
            border-radius: 0 0 6px 6px;
            padding: 15px 0;
            background: ${({ theme }) => theme['bg-color-light']};
            color: ${({ theme }) => theme['light-light']};
            svg{
                width: 15px;
                height: 15px;
                ${({ theme }) => (theme.rtl ? 'margin-left' : 'margin-right')}: 8px;
            }
        }
    }
`;

const AtbdTopDropdwon = Styled.div`
    .atbd-top-dropdwon__title .title-text {        
        ${({ theme }) => (!theme.rtl ? 'margin-right' : 'margin-left')}: 10px;
    }
    .atbd-top-dropdwon__content figcaption .atbd-top-dropdwonText {
        min-width: 216px;
        ${({ theme }) => (!theme.rtl ? 'margin-right' : 'margin-left')}: 15px;
    }
    .atbd-top-dropdwon__content .notification-icon {
        width: 39.2px;
        height: 32px;
        ${({ theme }) => (!theme.rtl ? 'margin-right' : 'margin-left')}: 15px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .atbd-top-dropdwon__content .notification-icon.bg-primary {
        background: #39318615;
        color: #393186;
    }
    .atbd-top-dropdwon__content .notification-icon.bg-secondary {
        background: #FF69A515;
        color: #FF69A5;
    }
    .atbd-top-dropdwon__content .notification-icon svg {
        width: 18px;
        height: 18px;
    }
    .atbd-top-dropdwon__content .notification-content {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }  

    .atbd-top-dropdwon__content figcaption span {
        ${({ theme }) => (theme.rtl ? 'padding-right' : 'padding-left')}: 0;
    }

    .notification-text h1 {
        font-size: 14px;
        font-weight: 400;
        color: #5A5F7D;
        margin-bottom: 4px;
    }

    .notification-text h1 span {
        color: #393186;
        font-weight: 500;
        ${({ theme }) => (theme.rtl ? 'padding-right' : 'padding-left')}: 0;
    }

    .notification-text p {
        font-size: 12px;
        color: #ADB4D2;
        margin-bottom: 0;
        text-align: ${({ theme }) => (!theme.rtl ? 'left' : 'right')}
    }
`;

const AtbdTopDropdwon1 = Styled.div`
    width:240px !important;
    display:flex;
    .atbd-top-dropdwon__nav {
        li {
            a {  
                padding: 10px 12px !important; 
                figure {
                    display:flex;
                    margin-bottom: 0;
                    figcaption {
                        display:flex;
                        h1 {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            font-size: 14px;
                            font-weight: 500;
                            margin-bottom: 0px;
                        }
                    }
                }
            }
            &:hover{
                background: #e5f2fd;
            }
            // .active{
            //     background: #e5f2fd;
            // }
            width: 100%;
        }
        &:last-child {
            margin: 0; 
        }
        
    }
       
    .atbd-top-dropdwon__content { align-items : center !important; }
    .atbd-top-dropdwon__content img { max-width: 30px!important; }
           
    .atbd-top-dropdwon__title .title-text {        
        ${({ theme }) => (!theme.rtl ? 'margin-right' : 'margin-left')}: 10px;
    }
    .atbd-top-dropdwon__content figcaption .atbd-top-dropdwonText {
        min-width: 140px;
        ${({ theme }) => (!theme.rtl ? 'margin-right' : 'margin-left')}: 15px;
    }
    

    .atbd-top-dropdwon__content figcaption span {
        ${({ theme }) => (theme.rtl ? 'padding-right' : 'padding-left')}: 0;
    }

    .atbd-top-dropdwon__content figcaption {  margin: 3px 7px; align-items: center; }

    .atbd-top-dropdwon__content  span svg{ color: #393186;  font-weight: 500; }

    
`;

const NavAuth = Styled.span`
    i, svg, img {
        ${({ theme }) => (theme.rtl ? 'margin-left' : 'margin-right')}: 8px;
        width:40px;
    }
`;


const LogoutButton = Styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.25s ease;
    svg {
        color : ${({ darkMode, theme }) => (darkMode ? '#1e1616ff' :  '#FFF')}
    }
    
    &:hover {
        padding: 8px 10px;
        background: rgba(255, 255, 255, 0.15);
    }

    &:active {
        transform: scale(0.96);
        background: rgba(255, 255, 255, 0.22);
    }
`;


export { LogoutButton, InfoWraper, SettingDropdwon, NestedDropdwon, UserDropDwon, AtbdTopDropdwon, AtbdTopDropdwon1, NavAuth };
